import React from 'react';
import { FormField, Label } from '@zillow/constellation-10';

import SwitchWithTitle from '../../../Widgets/SwitchWithTitle';

type Props = {
  header: string;
  subheader: string;
  switchOn: boolean | null;
  onSwitchToggle: () => void;
};

export default function HeaderToggle({ header, subheader, switchOn, onSwitchToggle }: Props): JSX.Element {
  return (
    <FormField
      optional
      label={<Label data-test="header">{header}</Label>}
      control={<SwitchWithTitle text={subheader} onClick={onSwitchToggle} toggled={switchOn} />}
    />
  );
}
